export function canShowMatchDemoDownload({ isLoggedIn, demoAvailable }) {
  return Boolean(isLoggedIn && demoAvailable);
}

export function buildMatchDemoDownloadUrl({ matchId, edgeBasePath }) {
  const normalizedBasePath = String(edgeBasePath || "").replace(/\/$/, "");
  return `${normalizedBasePath}/api/v1/match/demo/${encodeURIComponent(
    matchId
  )}`;
}
